import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=705ed1cc&scoped=true"
import script from "./Client.vue?vue&type=script&lang=js"
export * from "./Client.vue?vue&type=script&lang=js"
import style0 from "./Client.vue?vue&type=style&index=0&id=705ed1cc&prod&lang=scss"
import style1 from "./Client.vue?vue&type=style&index=1&id=705ed1cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705ed1cc",
  null
  
)

export default component.exports